import { useRef, useEffect } from 'react'

export function useParallax(speed = 0.35) {
  const imgRef = useRef<HTMLImageElement>(null)

  useEffect(() => {
    const img = imgRef.current
    if (!img) return

    const update = () => {
      const section = img.closest('.page-hero') as HTMLElement | null
      if (!section) return
      const rect = section.getBoundingClientRect()
      if (rect.bottom < 0 || rect.top > window.innerHeight) return
      const offset = rect.top * speed
      img.style.transform = `translateY(${offset}px) scale(1.15)`
    }

    window.addEventListener('scroll', update, { passive: true })
    update()
    return () => window.removeEventListener('scroll', update)
  }, [speed])

  return imgRef
}
